import React, { useState } from 'react';
import dridhLogo from '../../assets/dridh-logo.png';

/**
 * Mobile Navigation Component
 * Provides expandable dropdown for navigation tabs on mobile devices
 */
function MobileNavigation({ 
  user, 
  activeTab, 
  setActiveTab, 
  availableTabs, 
  onLogout,
  showUserMenu = true
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  const currentTab = availableTabs.find(tab => tab.id === activeTab) || availableTabs[0];

  const handleTabSelect = (tabId) => {
    setActiveTab(tabId);
    setShowDropdown(false);
  };

  return (
    <>
      {/* Top Navigation Bar */}
      <div style={{
        position: 'sticky',
        top: 0,
        backgroundColor: '#F5F3EB',
        color: '#1A3E2A',
        padding: '12px 16px',
        zIndex: 100,
        borderBottom: '1px solid #E3DFD3',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center' 
        }}>
          {/* Logo/Title */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            fontSize: '16px',
            fontWeight: '700'
          }}>
            <img src={dridhLogo} alt="Dridh" style={{ display: 'block', height: '32px', width: 'auto' }} />
            <span style={{ fontFamily: 'var(--font-family-display)' }}>PMS Admin</span>
          </div>

          {/* User Menu */}
          {showUserMenu && user && (
            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setShowUserDropdown(!showUserDropdown)}
                style={{
                  backgroundColor: 'transparent',
                  border: '1px solid #D2CDBF',
                  color: '#1A3E2A',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                {user.name?.split(' ')[0] || 'User'} ▼
              </button>

              {/* User Dropdown */}
              {showUserDropdown && (
                <>
                  {/* Backdrop */}
                  <div
                    onClick={() => setShowUserDropdown(false)}
                    style={{
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 99
                    }}
                  />
                  
                  {/* Dropdown Content */}
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: '8px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    minWidth: '200px',
                    zIndex: 100,
                    overflow: 'hidden',
                    border: '1px solid #E3DFD3'
                  }}>
                    <div style={{ 
                      padding: '12px 16px',
                      borderBottom: '1px solid #E3DFD3',
                      backgroundColor: '#F5F3EB'
                    }}>
                      <div style={{ 
                        fontSize: '14px', 
                        fontWeight: '600', 
                        color: '#1A3E2A' 
                      }}>
                        {user.name}
                      </div>
                      <div style={{ 
                        fontSize: '12px', 
                        color: '#5F6B61',
                        marginTop: '2px'
                      }}>
                        {user.email}
                      </div>
                      <div style={{ 
                        fontSize: '11px', 
                        color: '#5F6B61',
                        marginTop: '4px',
                        fontWeight: '600'
                      }}>
                        {user.role}
                      </div>
                    </div>
                    
                    <button
                      onClick={() => {
                        setShowUserDropdown(false);
                        onLogout && onLogout();
                      }}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        backgroundColor: 'white',
                        color: '#8E3628',
                        border: 'none',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        textAlign: 'left',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* Current Tab Selector */}
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          style={{
            width: '100%',
            marginTop: '12px',
            padding: '12px 16px',
            backgroundColor: '#1A3E2A',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <span>
            {currentTab.label}
          </span>
          <span style={{ 
            fontSize: '12px',
            transition: 'transform 0.2s',
            transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)'
          }}>
            ▼
          </span>
        </button>
      </div>

      {/* Tabs Dropdown */}
      {showDropdown && (
        <>
          {/* Backdrop to close dropdown */}
          <div
            onClick={() => setShowDropdown(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 99
            }}
          />
          
          {/* Dropdown Menu */}
          <div style={{
            position: 'fixed',
            top: '120px', // Below the nav bar
            left: '16px',
            right: '16px',
            backgroundColor: '#E9DFCE',
            borderRadius: '12px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
            zIndex: 100,
            maxHeight: 'calc(100vh - 140px)',
            overflowY: 'auto',
            border: '1px solid #E3DFD3'
          }}>
            {availableTabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabSelect(tab.id)}
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  backgroundColor: activeTab === tab.id ? '#F0F3EE' : 'white',
                  color: activeTab === tab.id ? '#1A3E2A' : '#36433B',
                  border: 'none',
                  borderBottom: '1px solid #E3DFD3',
                  fontSize: '14px',
                  fontWeight: activeTab === tab.id ? '600' : '500',
                  cursor: 'pointer',
                  textAlign: 'left',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.2s'
                }}
              >
                <div>
                  <div>{tab.label}</div>
                  {tab.description && (
                    <div style={{ 
                      fontSize: '11px', 
                      color: '#5F6B61',
                      marginTop: '2px'
                    }}>
                      {tab.description}
                    </div>
                  )}
                </div>
                {activeTab === tab.id && (
                  <span style={{ marginLeft: 'auto', fontSize: '16px' }}>✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}

/**
 * Mobile Bottom Navigation Bar (Alternative)
 * Fixed bottom navigation with quick access to main tabs
 */
export function MobileBottomNav({ activeTab, setActiveTab, quickTabs }) {
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
      borderTop: '1px solid #E3DFD3',
      padding: '8px 0',
      display: 'flex',
      justifyContent: 'space-around',
      zIndex: 100,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
    }}>
      {quickTabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '4px',
            backgroundColor: 'transparent',
            border: 'none',
            padding: '8px 4px',
            cursor: 'pointer',
            color: activeTab === tab.id ? '#1A3E2A' : '#5F6B61',
            fontSize: '10px',
            fontWeight: activeTab === tab.id ? '600' : '500',
            transition: 'all 0.2s'
          }}
        >
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  );
}

export default MobileNavigation;
